module.exports = __webpack_public_path__ + "resources/img/sp_intro2_m.d4019c121c5f6ac1ba98d452007a6cb4.png";